import { createSlice } from "@reduxjs/toolkit";
const initial_State = {
  FindBillingProviders: [],
  FindSupervisingProviders: [],
  FindOrderingProviders: [],
  FindAttendingProviders: [],
  FindModifiers: [],
  FindVisitStatusCodes: [],
  FindPos: [],
  FindRefProviders: [],
  FindLocations: [],
  FindTaxonomy: [],
  FindReceivers: [],
  FindERAClaimStatusCodes: [],
  FindTaskType: [],
  FindTaskPriority: [],
  FindTaskStatus: [],
  FindTask: [],
  ClaimStatusCodes: [],
  FindWriteOffCodes: [],

};
export const DataSlice = createSlice({
  name: "DataSlice",
  initialState: initial_State,
  reducers: {
    asyncSelector: (state, action) => {
      const endpoint = action.payload.endpoint;
      if (state[endpoint]) return state;

      state[endpoint] = { loading: true, data: null, error: null };
    },
    asyncSelectorSuccess: (state, action) => {
      const { endpoint, data } = action.payload;
      state[endpoint] = { loading: false, data, error: null };
    },
    asyncSelectorFailure: (state, action) => {
      const { endpoint, error } = action.payload;
      state[endpoint] = { loading: false, data: null, error };
    },
    dataSliceAction: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    setStatusData: (state, action) => {
      const { dataModel } = action.payload;
      state.ClaimStatusCodes = dataModel;  // Store status data in state
    },
    getWriteOffCodes: (state, action) => {
      state.FindWriteOffCodes = action.payload;
    },
  },



});

export const {
  asyncSelector,
  setStatusData,
  asyncSelectorSuccess,
  asyncSelectorFailure,
  dataSliceAction,
  getWriteOffCodes,
} = DataSlice.actions;

export default DataSlice.reducer;
